import { useCallback } from 'react';

// ----------------------------------------------------------------------

const OTP_MOBILE_KEY = 'otp_mobile';
const OTP_PURPOSE_KEY = 'otp_purpose';
const OTP_SESSION_KEY = 'otp_session';
const OTP_EXPIRE_AT_KEY = 'otp_expire_at';

export function useOtpSession() {
  // ======================
  // Basic setters
  // ======================

  const setOtpRequest = useCallback((mobile: string, purpose: string) => {
    sessionStorage.setItem(OTP_MOBILE_KEY, mobile);
    sessionStorage.setItem(OTP_PURPOSE_KEY, purpose);
  }, []);

  const setOtpSession = useCallback(
    (session: string) => sessionStorage.setItem(OTP_SESSION_KEY, session),
    []
  );

  // ======================
  // Timer logic
  // ======================

  const startOtpTimer = useCallback((seconds: number) => {
    const expireAt = Date.now() + seconds * 1000;
    sessionStorage.setItem(OTP_EXPIRE_AT_KEY, expireAt.toString());
  }, []);

  const getRemainingSeconds = useCallback((): number => {
    const expireAt = sessionStorage.getItem(OTP_EXPIRE_AT_KEY);
    if (!expireAt) return 0;

    const diff = Math.floor((Number(expireAt) - Date.now()) / 1000);
    return diff > 0 ? diff : 0;
  }, []);

  const clearOtpTimer = useCallback(() => sessionStorage.removeItem(OTP_EXPIRE_AT_KEY), []);

  // ======================
  // Getters
  // ======================

  const getOtpMobile = useCallback(() => sessionStorage.getItem(OTP_MOBILE_KEY) ?? '', []);

  const getOtpPurpose = useCallback(() => sessionStorage.getItem(OTP_PURPOSE_KEY) ?? '', []);

  const getOtpSession = useCallback(() => sessionStorage.getItem(OTP_SESSION_KEY) ?? '', []);

  const getMaskedMobile = useCallback(() => {
    const mobile = sessionStorage.getItem(OTP_MOBILE_KEY);
    if (!mobile) return '';
    return `${mobile.slice(0, 4)}*****${mobile.slice(-2)}`;
  }, []);

  const clearOtpKeys = useCallback(() => {
    sessionStorage.removeItem(OTP_MOBILE_KEY);
    sessionStorage.removeItem(OTP_PURPOSE_KEY);
    sessionStorage.removeItem(OTP_SESSION_KEY);
    sessionStorage.removeItem(OTP_EXPIRE_AT_KEY);
  }, []);

  return {
    // setters
    setOtpRequest,
    setOtpSession,

    // timer
    startOtpTimer,
    getRemainingSeconds,
    clearOtpTimer,

    // getters
    getOtpMobile,
    getOtpPurpose,
    getOtpSession,
    getMaskedMobile,

    clearOtpKeys,
  };
}
